import { ReactNode } from 'react';
import { Group, Text } from '@mantine/core';
import { IconBan } from '@tabler/icons-react';

import Chip, { ChipProps } from '@/components/Chip';

import { QuickAction } from '../types';

type QuickActionsProps = {
  onAction: (action: QuickAction) => void;
  disabled: boolean;
  activeAction?: QuickAction;
};

type QuickActionConfig = {
  value: QuickAction;
  label: ReactNode;
  color?: ChipProps['color'];
};

const ACTIONS: QuickActionConfig[] = [
  { value: QuickAction.MON_FRI, label: 'Mon-Fri' },
  { value: QuickAction.EVERYDAY, label: 'Every day' },
  {
    value: QuickAction.UNAVAILABLE,
    color: 'red',
    label: (
      <Group gap={4} wrap="nowrap" component="span">
        <IconBan size={14} />
        Unavailable this month
      </Group>
    ),
  },
];

const QuickActions: React.FC<QuickActionsProps> = ({ onAction, disabled, activeAction }) => (
  <Group gap="xs" align="center">
    <Text size="sm" c="black">
      Available:
    </Text>
    {ACTIONS.map(({ value, label, color }) => {
      const isChecked = activeAction === value;
      return (
        <Chip
          key={value}
          checked={isChecked}
          onChange={() => onAction(value)}
          disabled={disabled}
          withCheckIcon={false}
          color={color}
          variant={isChecked ? 'light' : 'outline'}
        >
          {label}
        </Chip>
      );
    })}
  </Group>
);

export default QuickActions;
